import React, { useState, useEffect } from 'react';
import BannerItem from 'features/app/components/banners/BannerItem';
import ListingItem from 'features/app/components/listings/ListingItem';
import PostItem from 'features/app/components/posts/PostItem';
import NotificationTemplateItem from 'features/crm/components/notification-templates/NotificationTemplateItem';
import NotificationItem from 'features/crm/components/notifications/NotificationItem';
import OrderItem from 'features/crm/components/orders/OrderItem';
import EmployeeGroupItem from 'features/company/components/employee-groups/EmployeeGroupItem';
import EmployeeItem from 'features/company/components/employees/EmployeeItem';
import StoreItem from 'features/company/components/stores/StoreItem';
import ConsultantItem from 'features/consultants/components/ConsultantItem';
import SectionItem from 'features/dev/components/sections/SectionItem';
import DocItem from 'features/docs/components/DocItem';
import ClientGroupItem from 'features/parties/components/client-groups/ClientGroupItem';
import ClientItem from 'features/parties/components/clients/ClientItem';
import SupplierGroupItem from 'features/parties/components/supplier-groups/SupplierGroupItem';
import SupplierItem from 'features/parties/components/suppliers/SupplierItem';
import CategoryItem from 'features/products/components/categories/CategoryItem';
import ProductGroupItem from 'features/products/components/product-groups/ProductGroupItem';
import ProductItem from 'features/products/components/products/ProductItem';
import ProjectItem from 'features/projects/components/ProjectItem';
import SnapItem from 'features/stats/components/snaps/SnapItem';
import { useStateContext } from 'shared/contexts/ContextProvider';
import { loadItem } from 'shared/api/requests';


const Item = ({ itemData, refreshList }) => {
    const [item, setItem] = useState(itemData);
    const [isLoading, setIsLoading] = useState(false);
    const { token } = useStateContext();
    
    
    const componentsMap = {
        'store': StoreItem,
        'employee': EmployeeItem,
        'employee-group': EmployeeGroupItem,
        'consultant': ConsultantItem,
        


        'client': ClientItem,
        'supplier': SupplierItem,
        'client-group': ClientGroupItem,
        'supplier-group': SupplierGroupItem,

        'doc': DocItem,
        
        'snap': SnapItem,

        'product': ProductItem,
        'category': CategoryItem,
        'product-group': ProductGroupItem,

        'section': SectionItem,

        'project': ProjectItem,
        
        'notification': NotificationItem,
        'notification-template': NotificationTemplateItem,
        'order': OrderItem,
        'post': PostItem,
        'banner': BannerItem,
        'listing': ListingItem,
    };

    console.log('itemData', itemData);

    useEffect(() => {
        console.log('itemData', itemData);
        
        // If itemData already has an id, it's complete data, no need to fetch
        if (itemData?.id) {
            setItem(itemData);
            setIsLoading(false);
            return;
        }

        // If itemData has meta.href but no id, fetch the complete data
        if (itemData?.meta?.href) {
            setIsLoading(true);
            const fetchItem = async () => {
                try {
                    const response = await loadItem(itemData.meta.href, '', token);
                    setItem(response);
                } catch (error) {
                    console.error("Error fetching item:", error);
                } finally {
                    setIsLoading(false);
                }
            };
            
            fetchItem();
        } else {
            // If no href, we still need to set the item and stop loading
            setItem(itemData);
            setIsLoading(false);
        }
    }, [itemData, token]);

   
    

    const type = item?.meta?.type;
    const SpecificComponent = componentsMap[type];

    // Show loading state while fetching data
    if (isLoading) {
        return <div className="flex justify-center items-center p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>;
    }

    // Don't render if we don't have item data yet
    if (!item) {
        return <div className="text-center text-gray-500 p-8">Loading...</div>;
    }

    if (SpecificComponent) {
        return <div className='p-4'>
            <SpecificComponent item={item} refreshList={refreshList} />
        </div>
    }

    return <div>Unknown item type "{type}"</div>;
};

export default Item;